












































import { Vue, Component, Model, Prop, Watch } from "vue-property-decorator";
import { BranchFilter } from "@/data/models/BranchFilter";
import { getBranchName } from "@/data/models/Branch";
import { getBranchFiltersOfMemberClient, getBranchFiltersOfUser } from "@/data/repository/UserRepository";
import User from "@/data/models/User";
import Client from "@/data/models/Client";
import { COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND } from "@/utils/colors";
import { hasClientEnabledStrictBranchFilters } from "@/data/repository/ClientRepository";
import { getEffectiveUser } from "@/utils/ViewAs";
import { setStoredBranchFilterId, removeStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component
export default class BranchFilterSelectorComponent extends Vue {
  @Prop({ default: null })
  targetUser!: User | null;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  showWhenSingleBranch!: boolean;

  @Prop({ default: false })
  showBranchesOfMember!: boolean;

  @Prop({ default: null })
  memberClient!: Client | null;

  @Watch("targetUser")
  onUserChanged(after: User | null, before: User | null) {
    const didUserChange = before != null && before?.id !== after?.id;

    if (didUserChange) {
      const defaultFilter = this.allBranchFilters[0];

      if (defaultFilter) {
        this.onSelectedBranchFilterChanged(defaultFilter);
      }
    }
  }

  get selectedValues() {
    const keySelected = this.getBranchOptionKeyCallback(
      this.selectedBranchFilter
    );

    return [keySelected];
  }

  get showSelector() {
    return (
      this.allBranchFilters.length > 0 &&
      (this.allBranchFilters.length > 1 || this.showWhenSingleBranch)
    );
  }

  get allBranchFilters() {
    let branchFilters: BranchFilter[] = [];

    if (this.showBranchesOfMember && this.memberClient) {
      branchFilters = getBranchFiltersOfMemberClient(this.memberClient);
    } else {
      // The given user's branches, else those of the user whose view the app shows: the chosen one
      // while "Sicht auf" is active (ticket 2610052), which covers screens that pass no user.
      branchFilters = getBranchFiltersOfUser(this.targetUser ?? getEffectiveUser());
    }

    if (branchFilters.length === 1 && this.showWhenSingleBranch) {
      const allBranchesFilter = new BranchFilter(
        hasClientEnabledStrictBranchFilters()
      );
      return [allBranchesFilter, branchFilters[0]];
    }

    return branchFilters;
  }

  get projectBranchIconRes() {
    return this.disabled ? "mdi-map-marker-off" : "mdi-map-marker";
  }

  @Model("selectedBranchFilter")
  selectedBranchFilter!: BranchFilter;

  onSelectedBranchFilterChanged(newFilter: BranchFilter) {
    this.$emit("selectedBranchFilter", newFilter);

    removeStoredBranchFilterId("branchFilter");
    if (newFilter?.branch?.id) {
      setStoredBranchFilterId("branchFilter", newFilter?.branch?.id);
    }
  }

  getBranchOptionKeyCallback(branchFilter: BranchFilter) {
    return branchFilter?.branch?.id ?? "all";
  }

  getBranchFilterName(branchFilter: BranchFilter) {
    return branchFilter.branch
      ? getBranchName(branchFilter.branch)
      : this.$t("common.all");
  }

  get style() {
    const hasSelectedFirstOption =
      this.getBranchOptionKeyCallback(this.allBranchFilters[0]) ==
      this.getBranchOptionKeyCallback(this.selectedBranchFilter);

    return hasSelectedFirstOption
      ? ""
      : `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`;
  }
}
